import { render, staticRenderFns } from "./update-invitation-email.vue?vue&type=template&id=491a413e&"
import script from "./update-invitation-email.vue?vue&type=script&lang=js&"
export * from "./update-invitation-email.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports